<div class="single-page">

      <app-carousel class="carousel"></app-carousel>

      <app-login class="content"></app-login>
</div>
<app-auth-footer></app-auth-footer>
